export const excludeData = (data, exclude) =>
  Object.keys(data)
    .filter((key) => !exclude.includes(key))
    .reduce((obj, key) => ({ ...obj, [key]: data[key] }), {})
